(function () {
  'use strict';
  angular.module('ringbaPortal').controller('TagSelectorController', TagSelectorController);

  function TagSelectorController(
    _,
    $filter,
    $timeout,
    userSettingsService,
    tagService,
    streamlinedZipcodeTagsService
  ) {
    'ngInject';

    const defaultZipcodeKey = streamlinedZipcodeTagsService.defaultZipcodeKey;

    const vm = this;
    let ngModelCtrl;
    const recentlyUsedTagsLimit = 10;

    // TODO: Get the comparison types from the service
    const MULTIPLE_COMPARISON = { key: 'EQUALS', value: 'EQUALS_MULTIPLE_VALUES', isNegativeMatch: false, forGeoTags: false, forBulkTags: true, forMultipleValues: true };
    const MULTIPLE_NEGATIVE_MATCH = { key: 'EQUALS', value: 'DOES_NOT_EQUAL_MULTIPLE_VALUES', isNegativeMatch: true, forGeoTags: false, forBulkTags: true, forMultipleValues: true };
    const managedTagsFromTo = [{ from: null, to: null }];

    vm.recentlyUsedTags = [];
    vm.searchEnabled = false;
    vm.zipcodeSource = {};
    vm.selectedKeyPair = {};
    vm.isNegativeMatch = false;

    vm.$onInit = onInit;
    vm.$onChanges = onChanges;
    vm.enableSearch = enableSearch;
    vm.searchTag = searchTag;
    vm.onFocusSearch = onFocusSearch;
    vm.onSelectTag = onSelectTag;
    vm.setNgModelController = setNgModelController;
    vm.onTagSourceClicked = onTagSourceClicked;
    vm.onNegativeMatchChange = onNegativeMatchChange;
    vm.BulkTagUploadSettings = streamlinedZipcodeTagsService.defaultBulkTagUploadSettings;
    vm.onUnselectedTag = onUnselectedTag;
    vm.onSubmitPressed = onSubmitPressed;


    // handleEnableSearch Has been defined on the controller in the tag-selector directive
    // not the best way to go about but more efficient than using broadcast
    // vm.handleEnableSearch = handleEnableSearch;
    function onInit() {
      _getRecentlyUsedTags();
      _loadStreamLinedZipcodeData();
    }

    function onChanges(changesObj) {
      if (changesObj.availableTags) {
        vm.availableTags = streamlinedZipcodeTagsService.expandToZipcodeTags(vm.availableTags, managedTagsFromTo);
        vm.tagSources = tagService.getTagSources(vm.availableTags);

        if (ngModelCtrl && angular.isDefined(ngModelCtrl.$modelValue)) {
          _resetModelValue();
        }
      }

      if (changesObj.comparisonNegativeMatch) {
        vm.isNegativeMatch = vm.comparisonNegativeMatch;
      }
    }

    function onTagSourceClicked(tagSource, resetZipComparisonType) {
      vm.isStreamlinedZipcodeActive[vm.andIndex + ':' + vm.orIndex] = vm.zipcodeSource[tagSource];
      if (vm.zipcodeSource[tagSource]) {
        if (!resetZipComparisonType) {
          vm.changeComparisonType(MULTIPLE_COMPARISON, vm.orIndex, vm.andIndex, vm.filter.tagCriteria[vm.orIndex]);
        }

        if (!vm.selectedTags || !streamlinedZipcodeTagsService.isZipcodeTypeTag(vm.selectedTags)) {
          _manageZipcodeTags(true);
        }
      }

      _syncSelectedTags();
    }

    function enableSearch() {
      _getRecentlyUsedTags().finally(_setFocusOnSearch);
    }

    function searchTag(searchString) {
      if (!searchString) {
        vm.searchFilteredTags = [];
        return;
      }
      searchString = searchString.toLowerCase();
      vm.searchFilteredTags = vm.availableTags.filter(function (tag) {
        return tag.tagName.toLowerCase().includes(searchString) || tag.tagType.toLowerCase().includes(searchString) || $filter('camelCaseFormat')(tag.tagName).toLowerCase().includes(searchString) || $filter('camelCaseFormat')(tag.tagType).toLowerCase().includes(searchString);
      });
      if (vm.isStreamlinedZipcodeActive[vm.andIndex + ':' + vm.orIndex]) {
        vm.activeTab = 0;
        vm.onTagSourceClicked('');
      }
    }

    function onFocusSearch() {
      if (!_isSetFocusOnStreamlinedZipcode()) {
        vm.activeTab = 0;
      }
    }

    function setNgModelController(ngModelController) {
      ngModelCtrl = ngModelController;
      ngModelCtrl.$render = renderViewValue;
    }

    function onSelectTag(tag, keepExisting) {
      onSelectTags([tag], keepExisting);
    }

    function onSelectTags(tags, keepExisting) {
      _saveMultipleTagsToRecentlyUsed(tags);

      if (!vm.selectedTags || !keepExisting) {
        vm.selectedTags = [];
      }

      const selectedTags = angular.copy(vm.selectedTags);
      _.forEach(streamlinedZipcodeTagsService.normalizeFromZipcodeTags(tags, managedTagsFromTo), function (tag) {
        tagService.pushDedupTag(selectedTags, tag);
      });

      _LoadSelectedTags(selectedTags);
    }

    function onUnselectedTag(tag) {
      if (tag) {
        const tags = angular.copy(vm.selectedTags);

        const comparisonTag = _.head(streamlinedZipcodeTagsService.normalizeFromZipcodeTags([tag], managedTagsFromTo));
        if (comparisonTag) {
          _.remove(tags, function (t) {
            return tagService.areEqualTags(t, comparisonTag);
          });
        }

        _LoadSelectedTags(tags);
      }
    }

    function renderViewValue() {
      if (ngModelCtrl.$viewValue && ngModelCtrl.$viewValue.length > 0) {
        vm.selectedTags = ngModelCtrl.$viewValue;
      }
    }

    function onNegativeMatchChange() {
      $timeout(function () {
        if (vm.isNegativeMatch) {
          vm.changeComparisonType(MULTIPLE_NEGATIVE_MATCH, vm.orIndex, vm.andIndex, vm.filter.tagCriteria[vm.orIndex]);
        } else {
          vm.changeComparisonType(MULTIPLE_COMPARISON, vm.orIndex, vm.andIndex, vm.filter.tagCriteria[vm.orIndex]);
        }
      }, 0);
    }

    function onSubmitPressed() {
      vm.searchEnabled = false;
      vm.searchTagId = '';
      vm.searchFilteredTags = [];
      vm.isStreamlinedZipcodeActive[vm.andIndex + ':' + vm.orIndex] = false;
    }

    function _LoadSelectedTags(tags) {
      vm.selectedTags = tags;
      ngModelCtrl.$setViewValue(vm.selectedTags);
    }

    function _resetModelValue() {
      // Force scope model value and ngModel value to be out of sync to re-run formatters
      ngModelCtrl.$modelValue = null;
    }

    function _saveMultipleTagsToRecentlyUsed(tags) {
      // Don't save the zip code tags for now
      if (!vm.isStreamlinedZipcodeActive[vm.andIndex + ':' + vm.orIndex]) {
        vm.searchEnabled = false;
        _.forEach(tags, function (tag) {
          _saveTagToRecentlyUsed(tag);
        });
      }
    }

    function _saveTagToRecentlyUsed(tag) {
      _getUserSettings().then(function (uiUserSettings) {
        uiUserSettings[vm.formNameForUserSettings] = uiUserSettings[vm.formNameForUserSettings] || {};
        vm.recentlyUsedTags = _addTagToUserSettings(uiUserSettings[vm.formNameForUserSettings], tag);
        userSettingsService.saveUserSettings(uiUserSettings);
      });
    }

    function _addTagToUserSettings(settings, tag) {
      settings.recentlyUsedTags = settings.recentlyUsedTags || [];
      settings.recentlyUsedTags.unshift(tag);
      settings.recentlyUsedTags = _.uniqBy(settings.recentlyUsedTags, function (findTag) {
        return findTag.tagType && findTag.tagName;
      });
      settings.recentlyUsedTags.length = settings.recentlyUsedTags.length > recentlyUsedTagsLimit ? recentlyUsedTagsLimit : settings.recentlyUsedTags.length;
      return settings.recentlyUsedTags;
    }

    function _loadStreamLinedZipcodeData() {
      vm.zipcodeSource[defaultZipcodeKey] = true;
    }

    function _getRecentlyUsedTags() {
      return _getUserSettings().then(function (uiUserSettings) {
        vm.recentlyUsedTags = uiUserSettings[vm.formNameForUserSettings] && uiUserSettings[vm.formNameForUserSettings].recentlyUsedTags || [];
        vm.recentlyUsedTags.length = vm.recentlyUsedTags.length > recentlyUsedTagsLimit ? recentlyUsedTagsLimit : vm.recentlyUsedTags.length;
      });
    }

    function _getUserSettings() {
      return userSettingsService.getUserSettings();
    }

    function _setFocusOnSearch() {
      vm.activeTab = 0;
      $timeout(function () {
        vm.searchEnabled = true;
        vm.handleEnableSearch();
      });
    }

    function _isSetFocusOnStreamlinedZipcode() {
      if (!vm.selectedTags) {
        return false;
      }
      if (streamlinedZipcodeTagsService.isZipcodeTypeTag(vm.selectedTags) && vm.selectedTags.length > 1) {

        vm.activeTab = (vm.tagSources.findIndex(function (item) { return item.id === defaultZipcodeKey; }) + 1);

        onTagSourceClicked(defaultZipcodeKey, true);

        return true;
      }

      return false;
    }

    function _syncSelectedTags() {
      Object.getOwnPropertyNames(vm.selectedKeyPair).forEach(function (tag) {
        vm.selectedKeyPair[tag] = false;
      });

      const selectedTags = streamlinedZipcodeTagsService.getExpandedZipcodeTags(vm.selectedTags);
      _.forEach(selectedTags, function (tag) {
        vm.selectedKeyPair[$filter('camelCaseFormat')(tag.tagType) + ':' + tag.tagName] = true;
      });
    }

    function _manageZipcodeTags(isSelected) {
      if (vm.availableTags) {

        const tags = streamlinedZipcodeTagsService.getPreSelectedTags(vm.availableTags);
        if (isSelected) {
          onSelectTags(tags, false);
        } else {
          _.forEach(tags, function (tag) {
            onUnselectedTag(tag);
          });
        }
      }
    }
  }
})();
